// extracted by mini-css-extract-plugin
export var compact = "_mo-2";
export var phoneFrame = "_mo-0";
export var phoneScreen = "_mo-1";